import React, { useMemo } from 'react';
import { Dropdown } from 'semantic-ui-react';
import InputWrap from './InputWrap';
import { ISelectProps } from './Select';
import styles from './styles/Select.module.scss';
import { toDropdownOptions } from 'helpers';

interface IMultiTextProps extends ISelectProps {
  value: string[];
}

const MultiText = ({
  basic,
  name,
  label,
  labelAfter,
  description,
  className,
  inputClassName,
  labelClassName,
  leftIcon,
  rightIcon,
  error,
  info,
  options = [],
  placeholder,
  tooltip,
  onChange,
  scrollIntoView,
  value = [],
  ...inputProps
}: IMultiTextProps) => {
  const handleChange = (_, data) => {
    if (onChange) {
      const target = { name: data.name, value: data.value };
      onChange({ target });
    }
  };

  const parsedOptions = useMemo(() => {
    const valueOpt = toDropdownOptions(value);
    return [...options, ...valueOpt];
  }, [name, options, value]);

  return (
    <InputWrap
      className={className}
      errorClassName={classnames(styles.error, basic && styles.basicError)}
      error={error}
      label={label}
      labelAfter={labelAfter}
      labelClassName={labelClassName}
      name={name}
      rightIcon={rightIcon}
      tooltip={tooltip}
      info={info}
      scrollIntoView={scrollIntoView}
    >
      <Dropdown
        className={classnames(
          styles.dropdown,
          styles.multi,
          value?.length > 0 && styles.hasValue,
          basic && styles.basic,
          inputClassName,
        )}
        name={name}
        placeholder={placeholder || ''}
        {...inputProps}
        scrolling={true}
        value={value}
        options={parsedOptions}
        onChange={handleChange}
        selection={true}
        search={true}
        icon={false}
        allowAdditions={true}
        multiple={true}
      />
    </InputWrap>
  );
};

export default MultiText;
